module.exports = __webpack_public_path__ + "static/media/HotelBooking.1aca6a55.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/HotelBooking.svg
// module id = 2601
// module chunks = 0